/* hk-product.js — PDP behaviour for sections/hk-product.liquid.
   Gallery: slide-swap + thumbnails + prev/next arrows + keyboard, ported from
   the prototype (happikiddo-storefront/assets/js/main.js slidePhoto/delegate
   and pages/product.html page script).
   Variant picker: prototype swatch pills wired as a real picker — selection
   updates the hidden variant id input (Horizon's <product-form-component>
   reads it on submit), price row, instalment line, stock line, add-to-cart
   button state and the gallery image, and mirrors the variant into the URL. */
(function () {
  'use strict';

  /* Slide the new photo in over the current one (prototype main.js). */
  var slideInFlight = null;   /* finish handler of the animation in progress */
  var slideSeq = 0;           /* latest click wins: stale image loads are discarded */

  function slidePhoto(scope, main, src, alt, thumb) {
    if (!src || main.getAttribute('src') === src) return;
    var container = main.parentNode;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !container) {
      main.src = src; if (alt) main.alt = alt;
      return;
    }
    var seq = ++slideSeq;
    var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-thumb-src]'));
    var newIdx = thumbs.indexOf(thumb), curIdx = -1;
    for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) curIdx = i; }
    var dir = (curIdx === -1 || newIdx > curIdx) ? 1 : -1;   /* 1: new enters from the right */

    var loader = new Image();
    loader.onload = function () {
      /* The animation starts here, async — a later click supersedes this one
         entirely, and any animation still running is settled instantly so
         slides never stack into a translucent pile. */
      if (seq !== slideSeq) return;
      if (slideInFlight) slideInFlight();
      var incoming = document.createElement('img');
      incoming.className = 'gal-slide';
      incoming.src = src; if (alt) incoming.alt = alt;
      incoming.style.transform = 'translateX(' + (dir * 100) + '%)';
      container.appendChild(incoming);
      void incoming.offsetWidth;   /* reflow so the start transform sticks */
      var ease = 'transform .5s cubic-bezier(.22,.61,.36,1)';
      main.style.transition = ease + ', opacity .5s ease';
      incoming.style.transition = ease;
      main.style.transform = 'translateX(' + (-dir * 100) + '%)';
      main.style.opacity = '0.4';
      incoming.style.transform = 'translateX(0)';
      var finished = false;
      var done = function () {
        if (finished) return;
        finished = true;
        if (slideInFlight === done) slideInFlight = null;
        main.style.transition = 'none';
        main.src = src; if (alt) main.alt = alt;
        main.style.transform = 'translateX(0)';
        main.style.opacity = '1';
        void main.offsetWidth;
        if (incoming.parentNode) incoming.parentNode.removeChild(incoming);
      };
      slideInFlight = done;
      incoming.addEventListener('transitionend', done);
      setTimeout(done, 650);   /* fallback if transitionend never fires */
    };
    loader.src = src;
  }

  function initGallery(root) {
    var scope = root.querySelector('[data-gallery]');
    if (!scope) return;
    var main = scope.querySelector('[data-gallery-main]');
    if (!main) return;

    /* Warm the CDN cache for every full-size gallery image so the first click
       on a thumb animates immediately instead of waiting on the download
       (the prototype ran on local files; Shopify images arrive over the CDN). */
    var warm = function () {
      var srcs = scope.querySelectorAll('[data-thumb-src]');
      for (var i = 0; i < srcs.length; i++) {
        new Image().src = srcs[i].getAttribute('data-thumb-src');
      }
    };
    if ('requestIdleCallback' in window) { requestIdleCallback(warm); } else { setTimeout(warm, 300); }

    function activateThumb(thumb) {
      slidePhoto(scope, main, thumb.getAttribute('data-thumb-src'), thumb.getAttribute('data-thumb-alt'), thumb);
      var thumbs = scope.querySelectorAll('[data-thumb-src]');
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('is-active', thumbs[i] === thumb);
      }
    }

    scope.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb-src]');
      if (!thumb || !scope.contains(thumb)) return;
      e.preventDefault();
      activateThumb(thumb);
    });

    /* Prev/next arrows + keyboard: step through the photo thumbnails. */
    var photoThumbs = function () {
      return [].slice.call(scope.querySelectorAll('.product-thumbs .product-thumb[data-thumb-src]'));
    };
    var step = function (dir) {
      var list = photoThumbs();
      if (!list.length) return;
      var idx = 0;
      for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('is-active')) { idx = i; break; } }
      var target = list[(idx + dir + list.length) % list.length];
      target.click();
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    var galMain = scope.querySelector('.product-gal-main');
    var prev = scope.querySelector('[data-gallery-prev]');
    var next = scope.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    if (galMain) {
      galMain.setAttribute('tabindex', '0');
      galMain.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      });

      /* Touch swipe on the main photo. Horizontal-dominant swipes step the
         gallery; vertical movement stays with the page scroll, so the
         thresholds compare axes rather than just measuring distance. */
      var touchX = null, touchY = null;
      galMain.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { touchX = null; return; }
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    /* Thumbnail strip scroll indicator: on mobile the strip overflows with
       nothing saying "this scrolls". Same bar the rails use (hk-rail.js /
       .rail-progress in hk-bridge.css); CSS keeps it mobile-only. */
    var thumbsEl = scope.querySelector('.product-thumbs');
    if (thumbsEl) {
      var progress = document.createElement('div');
      progress.className = 'rail-progress';
      var pThumb = document.createElement('span');
      pThumb.className = 'rail-progress-thumb';
      progress.appendChild(pThumb);
      thumbsEl.parentNode.insertBefore(progress, thumbsEl.nextSibling);
      var updateThumbProgress = function () {
        var overflow = thumbsEl.scrollWidth - thumbsEl.clientWidth;
        if (overflow <= 1) { progress.classList.remove('is-scrollable'); return; }
        progress.classList.add('is-scrollable');
        pThumb.style.width = (thumbsEl.clientWidth / thumbsEl.scrollWidth * 100) + '%';
        pThumb.style.left = (thumbsEl.scrollLeft / thumbsEl.scrollWidth * 100) + '%';
      };
      thumbsEl.addEventListener('scroll', updateThumbProgress, { passive: true });
      window.addEventListener('resize', updateThumbProgress);
      window.addEventListener('load', updateThumbProgress);
      updateThumbProgress();
    }

    return { activateThumb: activateThumb, main: main, scope: scope };
  }

  function initVariants(root, gallery) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var selected;
    try { selected = JSON.parse(root.getAttribute('data-selected-options') || '[]'); } catch (err) { selected = []; }

    var priceEl = root.querySelector('[data-price]');
    var instalmentEl = root.querySelector('[data-instalment]');
    var instalmentAmountEl = root.querySelector('[data-instalment-amount]');
    var stockEl = root.querySelector('[data-stock]');
    var variantInput = root.querySelector('input[name="id"]');
    /* The add-to-cart-button snippet renders no .add-to-cart-button class —
       the button is "button {{ class }}" — so select by the id the section
       passes in, with the class kept as a fallback. */
    var atcButton = root.querySelector('#HkProductSubmitButton, .add-to-cart-button');
    var buyNowEl = root.querySelector('.pdp-buy-it-now');
    var textAtc = root.getAttribute('data-text-atc') || 'Add to cart';
    var textSoldOut = root.getAttribute('data-text-soldout') || 'Sold out';
    var productUrl = root.getAttribute('data-product-url') || window.location.pathname;

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (variants[i].options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function setButtonText(text) {
      if (!atcButton) return;
      var span = atcButton.querySelector('.add-to-cart-text__content span span');
      if (span) span.textContent = text;
    }

    function applyVariant(variant) {
      var available = !!(variant && variant.available);

      if (variant && variantInput) variantInput.value = variant.id;

      if (variant) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* non-blocking */ }
      }

      if (priceEl && variant) {
        priceEl.classList.toggle('is-sale', !!variant.compare_f);
        priceEl.innerHTML = '';
        priceEl.appendChild(document.createTextNode(variant.price_f));
        if (variant.compare_f) {
          priceEl.appendChild(document.createTextNode(' '));
          var was = document.createElement('span');
          was.className = 'price-was';
          was.textContent = variant.compare_f;
          priceEl.appendChild(was);
        }
      }

      if (instalmentEl) {
        if (variant && variant.monthly_f) {
          instalmentEl.hidden = false;
          if (instalmentAmountEl) instalmentAmountEl.textContent = variant.monthly_f;
        } else {
          instalmentEl.hidden = true;
        }
      }

      if (stockEl) stockEl.hidden = !available;

      var restockEl = root.querySelector('[data-restock]');
      if (restockEl) restockEl.hidden = available;

      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice && variant) stickyPrice.textContent = variant.price_f;
      var stickyBtn = root.querySelector('[data-sticky-atc-button]');
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = variant ? (available ? textAtc : textSoldOut) : 'Unavailable';
      }

      if (atcButton) {
        atcButton.disabled = !available;
        setButtonText(variant ? (available ? textAtc : textSoldOut) : 'Unavailable');
      }

      /* Buy it now skips the cart, so it has to follow availability the same
         way Add to cart does. Shopify's own button does not track our variant
         switch, and it is rendered server-side, so hide the wrapper. */
      if (buyNowEl) buyNowEl.hidden = !available;

      /* Swap the gallery to the variant's photo, reusing the thumb slide. */
      if (variant && variant.media_id && gallery) {
        var thumb = gallery.scope.querySelector('[data-media-id="' + variant.media_id + '"]');
        if (thumb && !thumb.classList.contains('is-active')) {
          gallery.activateThumb(thumb);
        } else if (!thumb && variant.image && gallery.main) {
          gallery.main.src = variant.image;
        }
      }
    }

    var pills = root.querySelectorAll('.product-swatch[data-option-index]');
    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        var idx = Number(pill.getAttribute('data-option-index'));
        var value = pill.getAttribute('data-value');
        selected[idx] = value;

        /* Move the selected state within this option's row. */
        var group = pill.closest('.product-swatch-row');
        if (group) {
          Array.prototype.forEach.call(group.querySelectorAll('.product-swatch'), function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-checked', 'false');
          });
        }
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');

        var label = root.querySelector('[data-option-label="' + idx + '"]');
        if (label) label.textContent = value;

        applyVariant(findVariant());
      });
    });
  }

  /* Sticky add-to-cart bar: visible only once the buy box's own CTA block has
     scrolled above the viewport, clicks through to the real add-to-cart
     button. A plain rAF-throttled scroll check rather than an
     IntersectionObserver: observers sit idle in backgrounded/embedded
     webviews, and the bar must never fail closed. */
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-sticky-atc]');
    var ctas = root.querySelector('.product-ctas');
    if (!bar || !ctas) return;

    /* Hidden while any part of the CTA block is at or below the top edge,
       shown once the whole block has scrolled past it. One rect read per
       scroll event; browsers already coalesce scroll events per frame, so
       no extra throttling layer. */
    function update() {
      bar.hidden = ctas.getBoundingClientRect().bottom > 0;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
    var realBtn = root.querySelector('#HkProductSubmitButton, .add-to-cart-button');
    if (stickyBtn && realBtn) {
      stickyBtn.addEventListener('click', function () {
        realBtn.click();
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-hk-product]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.hkProductInit) return;
      root.dataset.hkProductInit = '1';
      var gallery = initGallery(root);
      initVariants(root, gallery);
      initStickyAtc(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
